import { callPlanet } from './'

export const postUniverseView = ({
  campaignCode,
  deviceType,
  locale,
  marketId,
  subUniverseKey,
  subUniverseName,
  universeKey,
  universeName
}) => (
  callPlanet('Universe/View', {
    campaignCode,
    deviceType,
    locale,
    marketId,
    subUniverseKey,
    subUniverseName,
    universeKey,
    universeName
  })
)
